export default "__VITE_ASSET__BGraIjBx__"